import styled from 'styled-components';
import { useEffect, useState } from 'react';

import information, { iBranchInfoDetail } from '../assets/text/information';
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from 'react-zoom-pan-pinch';

import photoOnedang from '../assets/1/map.webp';
import photoPyeongtaek from '../assets/2/map.webp';
import photoYeongdeungpo from '../assets/3/map.webp';
import photoWonju from '../assets/4/map.webp';
import photoDaegu from '../assets/5/map.webp';
import photoBugae from '../assets/6/bugae_map.webp';
import photoYongam from '../assets/7/map_cj.webp';
import photoAnyang from '../assets/8/anyang_map.webp';
import photoJeongwang from '../assets/9/map_jw.webp';
import photoYongsan from '../assets/10/map_ys.webp';
import photoGyeyang from '../assets/11/map_gy.webp';
import photoBokdae from '../assets/12/bd_map.webp';
import photoApgujeong from '../assets/13/ap_map.webp';
import photoAmsa from '../assets/14/as_map.webp'
import photoBaegot from '../assets/15/map_bg.webp';
import photoHakik from '../assets/16/hk_map.webp';
import photoSeouluni from '../assets/17/sw_map.webp';
import photoByeoryang from '../assets/20/by_map.webp';
import photoJakjeon from '../assets/21/map_jj.webp';
import photoBangi from '../assets/24/map.webp'
import photoYullyang from '../assets/26/map.webp'

import { useBranch } from '../contexts/BranchContext';

const ImgWrapper = styled.div`
  width: 100%;
  height: 30rem;
  margin: auto;
  overflow: hidden;
  cursor: pointer;
  border: ${({ theme }) => theme.boxBorder};

  @media (max-width: 1080px) {
    height: 50%;
  }

  > img {
    width: 100%;
    object-fit: cover;
    object-position: center 32% !important;
  }
`;

const Contents = styled.div`
  width: 100%;
  div,
  span,
  a,
  p,
  article {
    font-size: 0.9rem !important;
  }

  > div:not(:last-child) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 5rem;
    border-bottom: ${({ theme }) => theme.boxBorder};
  }

  .header {
    width: 13rem;
    display: block;
    font-size: 0.9rem !important;
    font-weight: bold !important;

    @media (max-width: 1080px) {
      width: 5.5rem;
    }

    > i {
      color: #b8b8b8;
      margin-right: 1rem;
      @media (max-width: 1080px) {
        margin-right: 0.5rem;
      }
    }
  }
  .content {
    width: calc(100% - 13rem);
    font-size: 0.9rem !important;
    color: ${({ theme }) => theme.color.sub};

    @media (max-width: 1080px) {
      width: calc(100% - 7rem);
    }
  }

  .address > .content {
    display: flex;
    flex-direction: column;
  }

  .phone > .content {
    @media (max-width: 1080px) {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    a {
      margin-right: 1rem;
    }
  }

  .service {
    height: 9rem;
    > .content {
      display: flex;
      > span {
        margin-right: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: end;
        align-items: center;
        @media (max-width: 1080px) {
          margin-right: 1rem;
        }
        > span {
          font-size: 3.5rem !important;

          @media (max-width: 1080px) {
            font-size: 1.5rem !important;
          }
        }
        .caption {
          font-size: 0.7rem !important;
        }
      }

      i {
        font-size: 3rem;
        font-weight: lighter;
        @media (max-width: 1080px) {
          font-size: 1.5rem;
        }
      }
      .fa-car {
        font-size: 1.5rem;
      }
    }
  }

  .bizInfo {
    width: 100%;
    display: flex;
    align-items: start;
    @media (max-width: 1080px) {
      flex-direction: column;
      .business {
        border-bottom: ${({ theme }) => theme.boxBorder};
      }
    }
  }

  .blog {
    .content {
      word-break: break-all; /* 단어 중간에서도 줄바꿈 */
      overflow-wrap: break-word; /* 긴 단어가 있을 경우 줄바꿈 */
      white-space: normal; /* 기본 줄바꿈 허용 */
    }
  }

  .business,
  .account {
    display: flex;
    justify-content: center;
    align-items: start;
    width: 50%;
    margin-top: 0;

    @media (max-width: 1080px) {
      width: 100%;
      justify-content: space-between;
    }

    .header {
      height: 100%;
      margin: auto;
      @media (max-width: 1080px) {
        width: 5.5rem !important;
        margin: auto 0;
      }
    }
    .content {
      height: 10rem;
      display: flex;
      flex-direction: column;
      padding-top: 1rem;

      @media (max-width: 1080px) {
        width: calc(100% - 7rem);
      }

      > span {
        display: flex;
        justify-content: space-between;
        .left {
          width: 5rem;
        }
        .right {
          width: calc(100% - 5rem);
        }
      }
    }
  }

  .further {
    @media (max-width: 1080px) {
      display: none;
    }
  }
`;

type Props = {
  info?: iBranchInfoDetail;
};

const icons = {
  park: () => (
    <span>
      <span>
        <i className="fa fa-car" aria-hidden="true"></i>P
      </span>
      <span className="caption">주차가능</span>
    </span>
  ),
  robotPark: () => (
    <span>
      <span>
        <i className="fa fa-car" aria-hidden="true"></i>P
      </span>
      <span className="caption">기계식주차가능</span>
    </span>
  ),
  separateToilet: () => (
    <span>
      <span>
        <i className="fa fa-male" aria-hidden="true"></i>|<i className="fa fa-female" aria-hidden="true"></i>
      </span>
      <span className="caption">남녀화장실구분</span>
    </span>
  ),
  wifi: () => (
    <span>
      <i className="fa fa-wifi" aria-hidden="true"></i>
      <span className="caption">와이파이제공</span>
    </span>
  ),
};

function Information({ info }: Props) {
  const branchImages: Record<string, string> = {
    onedang: photoOnedang,
    pyeongtaek: photoPyeongtaek,
    yeongdeungpo: photoYeongdeungpo,
    wonju: photoWonju,
    daegu: photoDaegu,
    bugae: photoBugae,
    yongam: photoYongam,
    anyang: photoAnyang,
    jeongwang: photoJeongwang,
    yongsan: photoYongsan,
    gyeyang: photoGyeyang,
    bokdae: photoBokdae,
    apgujeong: photoApgujeong,
    amsa: photoAmsa,
    baegot: photoBaegot,
    hakik: photoHakik,
    seouluni: photoSeouluni,
    byeoryang: photoByeoryang,
    jakjeon: photoJakjeon,
    bangi: photoBangi,
    yullyang: photoYullyang
  };
  const [branch, _] = useBranch();
  const [currPhoto, setPhoto] = useState<string>();

  const handleOpenNewTab = (url: string | undefined) => {
    window.open(url, '_blank', 'noopener, noreferrer');
  };

  const zoomInTooMuch = (e: ReactZoomPanPinchRef, url: string | undefined) => {
    if (e?.state?.scale > 2 && e?.state?.scale > e.state.previousScale) {
      if (window.confirm('네이버 지도로 확인하시겠습니까?')) {
        handleOpenNewTab(url);
      }
    }
  };
  useEffect(() => {
    const path = info?.path || 'onedang';
    branch !== '/' ? setPhoto(branchImages[branch]) : setPhoto(branchImages[path]);
  }, [info?.path, branch]);

  return (
    <>
      <TransformWrapper initialScale={1} minScale={1} maxScale={10} onZoom={(e) => zoomInTooMuch(e, info?.map)}>
        <TransformComponent>
          <ImgWrapper
            onClick={() => {
              handleOpenNewTab(info?.map);
            }}
          >
            <img src={currPhoto} alt="location" />
          </ImgWrapper>
        </TransformComponent>
      </TransformWrapper>
      <Contents>
        <div className="address">
          <span className="header">
            <i className="fa fa-location-arrow" aria-hidden="true"></i>
            오시는길
          </span>
          <span className="content">
            <span>{info?.address}</span>
            {info?.oldAddress && <span>(지번 : {info.oldAddress})</span>}
          </span>
        </div>
        <div>
          <span className="header">
            <i className="fa fa-clock-o" aria-hidden="true"></i>이용시간
          </span>
          <span className="content">{info?.time}</span>
        </div>
        <div className="phone">
          <span className="header">
            <i className="fa fa-phone" aria-hidden="true"></i>전화번호
          </span>
          <span className="content">
            {info?.phone && <a href={'tel:' + info?.phone.replace(/\D/g, '')}>{info?.phone}</a>}
            {info?.tel && <a href={'tel:' + info?.tel.replace(/\D/g, '')}>{info?.tel}</a>}
          </span>
        </div>
        {info?.blog && (
          <div className="blog">
            <span className="header">
              <i className="fa fa-id-card" aria-hidden="true"></i>블로그
            </span>
            <span className="content">
              <a href={info?.blog} target="_blank" rel="noopener noreferrer">
                {info?.blog}
              </a>
            </span>
          </div>
        )}
        <div className="service">
          <span className="header">
            <i className="fa fa-info-circle" aria-hidden="true"></i>이용안내
          </span>
          <span className="content">
            {info?.service?.park && icons.park()}
            {info?.service?.robotPark && icons.robotPark()}
            {info?.service?.wifi && icons.wifi()}
            {info?.service?.genderSeparateToilet && icons.separateToilet()}
          </span>
        </div>
        <div className="bizInfo">
          <div className="business">
            <span className="header">
              <i className="fa fa-briefcase" aria-hidden="true"></i>사업자정보
            </span>
            <span className="content ">
              <span>
                <span className="left">상호명</span>
                <span className="right">{info?.business?.name}</span>
              </span>
              <span>
                <span className="left">대표자</span>
                <span className="right">{info?.business?.owner}</span>
              </span>
              <span>
                <span className="left">사업자번호</span>
                <span className="right">{info?.business?.businessNo}</span>
              </span>
              <span>
                <span className="left">이메일</span>
                <a className="right">{info?.business?.email}</a>
              </span>
            </span>
          </div>
          <div className="account">
            <span className="header">
              <i className="fa fa-credit-card" aria-hidden="true"></i>입금계좌
            </span>
            <span className="content">
              <span>
                <span className="left">예금주</span>
                <span className="right">{info?.account?.owner}</span>
              </span>
              <span>
                <span className="left">입금은행</span>
                <span className="right">{info?.account?.bank}</span>
              </span>
              <span>
                <span className="left">계좌번호</span>
                <span className="right">{info?.account?.accountNo}</span>
              </span>
              <span>
                <span className="left"></span>
                <span className="right further">※입금하실 때 정보를 잘 입력해주세요</span>
              </span>
            </span>
          </div>
        </div>
      </Contents>
    </>
  );
}

export default Information;
